const gameName = process.env.GAME_NAME || "Prescott & Kreuger";

const loadingColour = process.env.LOADING_BG || "#676299";
const loadingTextColour = process.env.LOADING_BG || "white";
const loadingSpin = false;

const buildEnvironment = process.env.REACT_APP_ENV || "test";

const webglPrefix =
  process.env.REACT_APP_WEBGL_PREFIX ||
  "https://cybersecurity-ethics.s3-ap-southeast-2.amazonaws.com/Development/Build/WebGLDevelopment";

const firebaseConfig = process.env.FIREBASE_CONFIG;

const endText =
  "Thank you for playing Prescott & Kreuger. Please close this tab to return to the survey to fill out the post-experiment questionnaire.";

const gtagID = process.env.GTAG_ID || "G-8WTCQZ90XK";

export {
  buildEnvironment,
  webglPrefix,
  firebaseConfig,
  loadingColour,
  loadingTextColour,
  gameName,
  loadingSpin,
  endText,
  gtagID,
};
